const validateOutputTableStatus = (statusText: string) => {
  const successTextList = ['Finalizado', 'success', 'granted', 'authorized']
  const pendingTextList = ['Pendente', 'Processando', 'running', 'queued', 'scheduled']
  const failedTextList = ['failed', 'Falhou']
  const blockTextList = ['block']

  return !(
    failedTextList.includes(statusText) ||
    blockTextList.includes(statusText) ||
    pendingTextList.includes(statusText) ||
    successTextList.includes(statusText)
  )
}

export default validateOutputTableStatus
